import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u7B80\u4F53\u4E2D\u6587",
  code: "zh-CN",
  messages: {
    alert: {
      close: "\u5173\u95ED"
    },
    authForm: {
      hidePassword: "\u9690\u85CF\u5BC6\u7801",
      showPassword: "\u663E\u793A\u5BC6\u7801",
      submit: "\u7EE7\u7EED"
    },
    banner: {
      close: "\u5173\u95ED"
    },
    calendar: {
      nextMonth: "\u4E0B\u4E2A\u6708",
      nextYear: "\u660E\u5E74",
      prevMonth: "\u4E0A\u4E2A\u6708",
      prevYear: "\u53BB\u5E74"
    },
    carousel: {
      dots: "\u9009\u62E9\u8981\u663E\u793A\u7684\u5E7B\u706F\u7247",
      goto: "\u8DF3\u8F6C\u5230\u7B2C {slide} \u9875",
      next: "\u4E0B\u4E00\u9875",
      prev: "\u4E0A\u4E00\u9875"
    },
    chatPrompt: {
      placeholder: "\u5728\u8FD9\u91CC\u8F93\u5165\u4F60\u7684\u6D88\u606F..."
    },
    chatPromptSubmit: {
      label: "\u53D1\u9001"
    },
    colorMode: {
      dark: "\u6DF1\u8272",
      light: "\u6D45\u8272",
      switchToDark: "\u5207\u6362\u5230\u6DF1\u8272\u6A21\u5F0F",
      switchToLight: "\u5207\u6362\u5230\u6D45\u8272\u6A21\u5F0F",
      system: "\u7CFB\u7EDF"
    },
    commandPalette: {
      back: "\u8FD4\u56DE",
      close: "\u5173\u95ED",
      noData: "\u6CA1\u6709\u6570\u636E",
      noMatch: "\u6CA1\u6709\u5339\u914D\u7684\u6570\u636E",
      placeholder: "\u8F93\u5165\u547D\u4EE4\u6216\u641C\u7D22..."
    },
    contentSearch: {
      links: "\u94FE\u63A5",
      theme: "\u4E3B\u9898"
    },
    contentSearchButton: {
      label: "\u641C\u7D22..."
    },
    contentToc: {
      title: "\u672C\u9875\u5185\u5BB9"
    },
    dashboardSearch: {
      theme: "\u4E3B\u9898"
    },
    dashboardSearchButton: {
      label: "\u641C\u7D22..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u6536\u8D77\u4FA7\u8FB9\u680F",
      expand: "\u5C55\u5F00\u4FA7\u8FB9\u680F"
    },
    dashboardSidebarToggle: {
      close: "\u5173\u95ED\u4FA7\u8FB9\u680F",
      open: "\u6253\u5F00\u4FA7\u8FB9\u680F"
    },
    error: {
      clear: "\u8FD4\u56DE\u9996\u9875"
    },
    fileUpload: {
      removeFile: "\u5220\u9664 {filename}"
    },
    header: {
      close: "\u5173\u95ED\u83DC\u5355",
      open: "\u6253\u5F00\u83DC\u5355"
    },
    inputMenu: {
      create: '\u521B\u5EFA "{label}"',
      noData: "\u6CA1\u6709\u6570\u636E",
      noMatch: "\u6CA1\u6709\u5339\u914D\u7684\u6570\u636E"
    },
    inputNumber: {
      decrement: "\u51CF\u5C11",
      increment: "\u589E\u52A0"
    },
    modal: {
      close: "\u5173\u95ED"
    },
    pricingTable: {
      caption: "\u4EF7\u683C\u8BA1\u5212\u6BD4\u8F83"
    },
    prose: {
      codeCollapse: {
        closeText: "\u6536\u8D77",
        name: "\u4EE3\u7801",
        openText: "\u5C55\u5F00"
      },
      collapsible: {
        closeText: "\u9690\u85CF",
        name: "\u5C5E\u6027",
        openText: "\u663E\u793A"
      },
      pre: {
        copy: "\u590D\u5236\u4EE3\u7801\u5230\u526A\u8D34\u677F"
      }
    },
    selectMenu: {
      create: '\u521B\u5EFA "{label}"',
      noData: "\u6CA1\u6709\u6570\u636E",
      noMatch: "\u6CA1\u6709\u5339\u914D\u7684\u6570\u636E",
      search: "\u641C\u7D22..."
    },
    slideover: {
      close: "\u5173\u95ED"
    },
    table: {
      noData: "\u6CA1\u6709\u6570\u636E"
    },
    toast: {
      close: "\u5173\u95ED"
    }
  }
});
